module.exports = __webpack_public_path__ + "img/fanxianAppImage.3bbecaf9.png";